<mat-dialog-content style="padding: 1px">
  <div class="container">
    <div class='row' >
      <div class = "col-11 col-sm-11" style = "margin: 20px; text-align: center;">
        <h2 class="doneLabel" style = "font-family: Lato, 'Alegreya Sans'; color: white; font-size: 40px; ">{{labels.lblAreYouSureSurvey}}</h2>

      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6" style = "margin: auto;">
        <button style=" height: 60px" class="login-button" (click)="voidUserResult()">
          <div class = "col-11" style = "margin: auto; ">
            <h3  class = "loginBtnLabel">{{labels.lblBackToTraining}}</h3>
          </div>
        </button>
      </div>
      <div class="col-12 col-sm-6" style = "margin: auto;">
        <button style=" height: 60px" class="login-button" (click)="closeDialog()">
          <div class = "col-11" style = "margin: auto; text-align: center;">
            <h3 class = "loginBtnLabel">{{labels.lblBackToTask}}</h3>
          </div>
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
